import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import {
  ANCHORDATACATEGORIES,
  ANCHORDATA_VIRTUAL_CATEGORY_MISSING_REQUIRED,
} from "@/helper/anchorDataCategories";
import StyledTab from "@/components/anchorData/styledTab";
import StyledTabs from "@/components/anchorData/styledTabs";

export interface ContractSetupTab {
  code: string;
  label: string;
}

interface CategoryTabPanelProps {
  onChange: (event: React.SyntheticEvent, newValue: string) => void;
  category: string | false;
  showMissingRequiredTab?: boolean;
  contractTabs?: ContractSetupTab[];
}

const CategoryTabPanel: FC<CategoryTabPanelProps> = ({
  onChange,
  category,
  showMissingRequiredTab = false,
  contractTabs = [],
}) => {
  const { t } = useTranslation();
  const selectedCategory =
    category === ANCHORDATA_VIRTUAL_CATEGORY_MISSING_REQUIRED &&
    !showMissingRequiredTab
      ? false
      : category;
  return (
    <>
      <StyledTabs value={selectedCategory} onChange={onChange}>
        {ANCHORDATACATEGORIES.map((category: any, idx: any) => (
          <StyledTab key={idx} value={category} label={category} />
        ))}
        {contractTabs.map((tab) => (
          <StyledTab key={tab.code} value={tab.code} label={tab.label} />
        ))}
        {showMissingRequiredTab && (
          <StyledTab
            value={ANCHORDATA_VIRTUAL_CATEGORY_MISSING_REQUIRED}
            label={t("anchordata_category_missing_required")}
          />
        )}
      </StyledTabs>
    </>
  );
};

export default CategoryTabPanel;
